import * as React from 'react';
import { useRouteData } from 'react-static';
import { SearchOptions, SearchType } from '../../common/d7/common';
import { getSearchResults } from '../../common/d7/search';
import { useDebug } from '../../common/hooks/useDebug';
import { useSearchResults } from '../../common/hooks/useSearchResults';
import { useTranslations } from '../../common/translation';
import { BannerCarousel } from '../../components/banner-carousel/BannerCarousel';
import { BrandsCollectionsResults } from '../../components/brands-collections-results/BrandsCollectionsResults';
import { BrandsUKCollectionsResults } from '../../components/brands-collections-results/BrandsUKCollectionsResults';
import { FeaturedBanner } from '../../components/featured-banner/FeaturedBanner';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { InstagramLoader } from '../../components/instagram-loader/InstagramLoader';
import { NoticeMessage } from '../../components/notice/Notice';
import { RowHeader } from '../../components/row-header/RowHeader';
import { MARKET } from '../../config/browser';
import { CollectionResults } from './collection-results/CollectionResults';
import { CollectionLayoutProps } from './CollectionLayout.props';
import { StyledCollectionLayout, StyledCollectionResultsLayout } from './CollectionLayout.styles';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const {
    image,
    locale,
    path,
    subtitle,
    title,
    hideExploreCollection,
    collectionTitleIds,
    notice,
    translatedPaths,
    seo,
    bannerTitle,
    bottomBannerProps,
    nids = [],
  } = useRouteData<CollectionLayoutProps>();
  const { t } = useTranslations(translations, locale);
  const type = SearchType.getNodes;
  const options: SearchOptions = {
    type,
    locale,
  };
  const results = useSearchResults(collectionTitleIds, getSearchResults, options);
  const { isLoading, searchResults } = results;
  const featuredBannerProps = {
    image: { src: image.src, alt: image.alt },
    titleProps: {
      title,
      addlTitleData: {
        marketingMessage: subtitle,
      },
    },
  };
  useDebug('app:layout:CollectionLayout', { props: { image, locale, path, seo, subtitle, title, translatedPaths } });

  return (
    <StyledCollectionLayout locale={locale} translatedPaths={translatedPaths} seo={seo}>
      <HeadTitle title={`${title} | ${t('pageTitle', 'Collections')}`} />
      <NoticeMessage notice={notice} />
      <FeaturedBanner headingTag='h1' {...featuredBannerProps} />
      {isLoading && <InstagramLoader />}
      {!isLoading && searchResults.length > 0 && <CollectionResults nodes={searchResults} />}
      {bannerTitle && <RowHeader headingTag='h2' title={bannerTitle} />}
      <BannerCarousel {...bottomBannerProps} addTopMargin={!bannerTitle} lazyLoad={true} />
      {!hideExploreCollection && (
        <StyledCollectionResultsLayout className='collections-container'>
          <RowHeader title={t('exploreCollectionsTitle', 'Explore Our Collections')} />
          {MARKET !== 'UK' && (
            <BrandsCollectionsResults
              key={title}
              contentType='Collections'
              query='f[0]=type:collections&qt=%20&size=10'
              skipItemPath={path.startsWith('/') ? path : `/${path}`}
            />
          )}
          {MARKET === 'UK' && (
            <BrandsUKCollectionsResults
              contentType='Collections'
              query='f[0]=type:collections&qt=%20&size=10'
              nids={nids}
              skipItemPath={path.startsWith('/') ? path : `/${path}`}
            />
          )}
        </StyledCollectionResultsLayout>
      )}
    </StyledCollectionLayout>
  );
};
